// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".th4R4rSL8pr4RcOR7xO8{margin-right:8px}", "",{"version":3,"sources":["webpack://./src/templates/projects/personal-projects-table-actions-cell.module.scss"],"names":[],"mappings":"AAAA,sBACM,gBAAA","sourcesContent":[".buttonMargin {\n      margin-right: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonMargin": "th4R4rSL8pr4RcOR7xO8"
};
export default ___CSS_LOADER_EXPORT___;
